import { Platform } from 'react-native'

import { env } from '@env'
import { getUserContext } from '@zet/feature-user/api/user/functions'
import { zetApi } from '@zet/network'
import { resetNavigation } from '@zet/utils/navigation'
import storageUtil from '@zet/utils/storage'
import Constants from 'expo-constants'

import useAuthStore from '../../store/authStore'

let zetUserApiRetryCount = 0

zetApi.defaults.baseURL = env.API_BASE_URL

//* All request will wait 3 seconds before timeout
zetApi.defaults.timeout = 30000
zetApi.defaults.headers.common = {
  Accept: 'application/json',
  appVersionNo: Constants?.expoConfig?.version,
  locale: 'en',
  appSource: 'bridge',
}
zetApi.defaults.withCredentials = false

zetApi.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    // Error block
    const originalRequest = error.config
    if (error?.response?.status === 502) {
      setTimeout(() => resetNavigation('ServerDownScreen'), 500)
      return
    }
    if (error?.response?.status === 401 && Platform.OS === 'android') {
      if (originalRequest?.url === 'enterprise/subAgent/getDetails') {
        if (zetUserApiRetryCount < 1) {
          checkUserIfIsBlocked()
        }
        zetUserApiRetryCount++
      } else {
        checkUserIfIsBlocked()
      }
    }
    handleUnauthorizedApiError(error, originalRequest)

    throw error
  }
)

const handleUnauthorizedApiError = (error: object, originalRequest: object) => {
  const excludedEndpoints = ['']
  if (
    error?.response?.status === 401 &&
    Platform.OS === 'web' &&
    !excludedEndpoints.includes(originalRequest?.url)
  ) {
    useAuthStore.setState({ unauthorizedApiError: true })
  }
}

export const changeLocaleInHeader = (locale = 'en') => {
  zetApi.defaults.headers.common = {
    ...zetApi.defaults.headers.common,
    locale: locale,
  }
}

const checkUserIfIsBlocked = async () => {
  try {
    const res = await getUserContext()
    if (res?.isAccBlocked) {
      setTimeout(() => resetNavigation('AccountBlockedScreen'), 500)
    } else {
      throw new Error('Something went wrong!')
    }
  } catch (error) {
    logout()
  }
}

const logout = async () => {
  zetUserApiRetryCount = 0
  storageUtil.mmkvStorage.clearAll()
  useAuthStore.setState({ isAuthenticated: false })
  useAuthStore.setState({ authToken: '' })
}

export { zetApi as bridgeApi }
